// component
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name, other, w = 22, h = 22) =>
  other ? (
    <img
      alt="navIcon"
      src={`${process.env.PUBLIC_URL}/assets/icons/navbar/${name}.${other}`}
      style={{ width: w, height: h }}
    />
  ) : (
    <SvgColor src={`${process.env.PUBLIC_URL}/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
  );

const MIS = [  
  {
    title: 'Ledger Followup Tracker',
    path: '/dashboard/manage/LedgerFollowupTracker',
    icon: icon('company', 'png'),
    ShortName: 'LedgerFollowupTracker',
  },
  {
    title: 'Order Followup Tracker',
    path: '/dashboard/manage/OrderFollowupTracker',
    icon: icon('company', 'png'),
    ShortName: 'OrderFollowupTracker',
  },
  {
    title: 'Complaint Review',
    path: '/dashboard/manage/ComplaintReview',
    icon: icon('company', 'png'),
    ShortName: 'ComplaintReview',
  },
  {
    title: 'Complaint Mail Log',
    path: '/dashboard/manage/ComplaintMailLog',
    icon: icon('company', 'png'),
    ShortName: 'ComplaintMailLog',
  }
];

export default MIS;
